<template>
  <div class="customer-timeline-event">
    <div class="customer-timeline-event__icon" :class="icon_class">
      <img :src="event_icon" :alt="event_title">
    </div>
    <div class="customer-timeline-event__content container-fluid">
      <div class="row">
        <div class="col-md-6 d-flex align-items-center">
          <div class="mr-2 customer-timeline-event__date">
            {{ event_date }}
          </div>
          &middot;
          <a class="ml-2 customer-timeline-event__title" @click="editEvent" :class="{ editable: is_editable }">
            {{ event_title }}
            <i v-if="is_editable" class="fas fa-edit"></i>
          </a>
        </div>
        <div class="col-md-6 d-flex align-items-center justify-content-end">
          <div v-if="!event.unpinnable" class="customer-timeline-event__pin-icon" :class="{ pinned: is_pinned }"
            @click="pinEvent">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
              <g clip-path="url(#clip0_220_194)">
                <path
                  d="M12.9941 6.35625C12.7996 6.61985 12.513 6.80068 12.1914 6.86284C11.8697 6.92501 11.5364 6.86397 11.2576 6.69185C11.1045 6.5905 11.1045 6.59275 10.9356 6.76391C10.109 7.60175 9.88149 7.82698 9.19229 8.50942L8.88373 8.81798C8.83481 8.86293 8.82642 8.86133 8.86346 8.91259C9.74185 10.2347 9.18328 11.7167 8.36571 12.6626C7.95023 13.1092 7.51863 13.1165 7.08191 12.7144C6.32256 11.9527 5.76249 11.4097 4.93775 10.5613C4.85909 10.4927 4.8929 10.48 4.78685 10.5613C4.1382 11.0928 3.48804 11.6213 2.83638 12.1468C2.44449 12.4644 2.05109 12.7827 1.65619 13.1018C1.53483 13.2186 1.37609 13.2888 1.20799 13.3C1.14237 13.2987 1.07768 13.2843 1.01772 13.2576C0.957757 13.2309 0.903753 13.1925 0.858891 13.1446C0.543573 12.836 0.777809 12.514 0.879161 12.3766C1.68938 11.2664 2.47945 10.1604 3.30711 9.05223C3.36704 8.96857 3.35729 8.98939 3.28459 8.91259C2.53713 8.17159 2.01874 7.6519 1.34763 6.97789C0.872247 6.5066 0.89956 6.03038 1.40619 5.59049C2.35665 4.76166 3.98504 4.32922 5.12469 5.16031C5.1337 5.16707 5.14046 5.17157 5.14721 5.17607C6.12885 4.18425 6.54837 3.76528 7.40624 2.9148C7.2001 2.63179 7.10801 2.28158 7.14825 1.93379C7.1885 1.58599 7.35815 1.26607 7.62348 1.03763C7.8888 0.809184 8.23038 0.688946 8.5803 0.700815C8.93021 0.712683 9.26285 0.855789 9.51209 1.10168C10.922 2.49811 11.5256 3.10397 12.9198 4.5094C13.1587 4.75338 13.2985 5.07733 13.3123 5.41852C13.326 5.75971 13.2126 6.09386 12.9941 6.35625Z"
                  fill="#A6AAB4" />
              </g>
              <defs>
                <clipPath id="clip0_220_194">
                  <rect width="14" height="14" fill="white" />
                </clipPath>
              </defs>
            </svg>
          </div>
        </div>
      </div>

      <timeline-event-quotation :event='this.event' @note="noteEvent" @done="doneEvent" @assign="assignEvent"
        :entity="entity" :doctor_names="doctor_names" @appointment="appointEvent" v-if="event.entity == 'Quotation'">
      </timeline-event-quotation>

      <timeline-event-treatment :event='this.event' @note="noteEvent" @done="doneEvent" @assign="assignEvent"
        :doctor_names="doctor_names" :entity="entity" @appointment="appointEvent"
        v-else-if="event.entity == 'Treatment'">
      </timeline-event-treatment>

      <timeline-event-appointment @done="doneEvent" @edit="editEvent" @note="noteEvent" @assign="assignEvent"
        :doctor_names="doctor_names" :event='this.event' @appointment="appointEvent" :entity="entity"
        v-else-if="event.entity == 'Appointment'">
      </timeline-event-appointment>

      <timeline-event-history-entry @done="doneEvent" @note="noteEvent" @assign="assignEvent" :event='this.event'
        :entity="entity" :doctor_names="doctor_names" @appointment="appointEvent"
        v-else-if="event.entity == 'HistoryEntry'">
      </timeline-event-history-entry>

      <timeline-event-labwork @edit="editEvent" :event='this.event' :entity="entity" :doctor_names="doctor_names"
        v-else-if="event.entity == 'LabWork'">
      </timeline-event-labwork>

      <div v-else>
        <strong>Entidad no reconocida. Avisar al Administrador</strong>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['event', 'entity', 'clinic', 'doctor_names'],
  data() {
    return {
    }
  },
  computed: {
    is_pinned() {
      return this.event.pinned;
    },
    is_editable() {
      return this.event.entity == 'HistoryEntry';
    },
    icon_class() {
      let ret = {};
      switch (this.event.entity) {
        case 'Treatment':
          switch (this.event.action) {
            case 'DONE':
              ret.green = true;
              break;
          }
          break;
        case 'Appointment':
          switch (this.event.action) {
            case 'DONE':
              ret.green = true;
              break;
            case 'FAILED':
              ret.red = true;
              break;
            default:
              ret.blue = true;
          }
          break;
      }

      return ret;
    },
    event_icon() {
      switch (this.event.entity) {
        case 'HistoryEntry':
        case 'LabWork':
          return '/img/icon-note.svg';
        case 'Quotation':
          return '/img/icon-plan.svg';
        case 'Treatment':
          return '/img/checkmark-white.svg';
        case 'Appointment':
          switch (this.event.action) {
            case 'FAILED':
              return '/img/icon-failed.svg';
          }
          return '/img/icon-appointment.svg';
      }
      return '/img/icon-note.svg';
    },
    event_title() {
      switch (this.event.entity) {
        case 'HistoryEntry':
          const title = this.entity.title;
          if (title && title !== '') {
            return 'Nota: ' + title;
          }
          return 'Nota';
        case 'LabWork':
          return 'Trabajo Laboratorio';
        case 'Quotation':
          switch (this.event.action) {
            case 'CREATED':
              return 'Plan Creado';
            case 'APPROVED':
              return 'Plan Aprobado';
          }
          break;
        case 'Treatment':
          switch (this.event.action) {
            case 'DONE':
              return 'Tratamiento Realizado';
          }
          break;
        case 'Appointment':
          switch (this.event.action) {
            case 'SCHEDULED':
              return 'Cita programada con : ' + this.event_doctor;
            case 'DONE':
              return 'Cita realizada con : ' + this.event_doctor;
            case 'FAILED':
              return 'Cita fallida con : ' + this.event_doctor;
          }
          break;
      }
      return this.event.entity + ' ' + this.event.action;
    },
    event_doctor() {
      if (this.entity && this.entity.doctor_id) {
        return this.doctor_names[this.entity.doctor_id] || '';
      }
      return '';
    },
    event_date() {
      switch (this.event.entity) {
        case 'Appointment':
          return moment(this.event.date).format('DD/MM/YY - HH:mm');
        default:
          return moment(this.event.date).format('DD/MM/YY');
      }
    },
  },
  methods: {
    assignEvent(event, treatment) {
      console.log('assign');
      this.$emit('assign', event, treatment);
    },
    pinEvent() {
      this.$emit('pin', this.event);
    },
    editEvent() {
      this.$emit('edit', this.event, this.entity);
    },
    doneEvent(event, treatment) {
      this.$emit('done', event, treatment);
    },
    noteEvent(event, treatment) {
      this.$emit('note', event, treatment);
    },
    appointEvent(event, treatment) {
      this.$emit('appointment', event, treatment);
    }
  }
}
</script>

<style lang="scss">
.customer-timeline-event {
  position: relative;
  width: 100%;

  &::before {
    display: block;
    content: '';
    position: absolute;
    width: 2px;
    height: calc(100% + 10px);
    top: 5px;
    left: 12px;
    background: var(--ui-gris-medio, #F9F9F8);
  }

  &__pin-icon {
    svg path {
      transition: .3s;
    }

    cursor: pointer;

    &.pinned svg path {
      fill: var(--theme-color-attended);
    }

    &:hover svg path {
      fill: var(--theme-color);
    }
  }

  &__icon {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 10px;
    background-color: #A6AAB4;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 15px;
    left: 3px;
    z-index: 1;

    img {
      width: 12px;
      height: 12px;
      object-fit: contain;
    }

    &.green {
      background-color: var(--theme-color-attended);
    }

    &.red {
      background-color: var(--theme-color-absent);
    }

    &.blue {
      background-color: #72B4E4;
    }
  }

  &__content {
    border-radius: 10px;
    background: var(--ui-gris-medio, #F9F9F8);
    margin: 0 0 10px 27px;
    padding-top: 10px;
    padding-bottom: 10px;
    width: calc(100% - 27px);
  }

  &__date,
  &__doctor {
    font-size: 18px;
    font-weight: 700;
    color: var(--theme-text-color);
  }

  &__title {
    font-size: 13px;
    font-weight: 700;
    color: var(--theme-grey);
    text-decoration: none;
    transition: .3s;
    text-transform: uppercase;
    cursor: pointer;

    i {
      opacity: 0;
      transition: .3s;
      color: var(--theme-color);
      margin-left: 5px;
      font-size: 75%;
    }

    &:hover {
      color: var(--theme-text-color);
      text-decoration: none;
    }

    &.editable {}

    &.editable:hover {
      text-decoration: none;
      color: var(--theme-color);

      i {
        opacity: 1;
      }
    }
  }
}
</style>
